import { pb } from "@/lib/pocketbase";

export interface ProgressData {
  progress: number;
  currentStage: string;
  message: string;
  isComplete: boolean;
  error?: string;
}

export const fetchArticleProgress = async (
  postId: string,
): Promise<ProgressData | null> => {
  try {
    const post = await pb.collection("posts").getOne(postId);

    if (!post.progress) {
      return null;
    }

    const data =
      typeof post.progress === "string"
        ? JSON.parse(post.progress)
        : post.progress;

    return {
      progress: data.percentage || 0,
      currentStage: data.stage || "research",
      message: data.message || "Processing...",
      isComplete: data.isCompleted || false,
      error: data.hasError ? data.message : undefined,
    };
  } catch (error) {
    console.error("Failed to fetch article progress:", error);
    throw error;
  }
};
